export default __webpack_public_path__ + "static/media/Cloudxier_graphics-each-expertise-03.889273e0.png";